import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import ChecklistContent from "../../components/Checklist/ChecklistContent";
import { useDispatch, useSelector } from "react-redux";
import {
  getDepartmentMasterList,
  getVesselMasterList,
} from "../../redux/actions/mastersAction";
const Checklist = () => {
  const dispatch = useDispatch();

  const CompanyID = localStorage.getItem("companyID");

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );

    dispatch(
      getVesselMasterList({
        active: "true",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);
  return (
    <>
      <Sidebar activeTab="Checklist" title="Checklist">
        <Box className="globalContainer_For_Content">
          <ChecklistContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default Checklist;
